import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ErrorModel {
  title: string;
  message: string;
}
@Component({
  selector: 'confirm',
  template: `<div
      class="modal-dialog modal-dialog-centered"
      data-backdrop="static"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="close()">&times;</button>
        </div>
        <div class="modal-body text-center">
          {{ error_message }}
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary hvr-bounce-to-top"
            (click)="confirm()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>`,
  styleUrls: ['./error.component.css'],
})
export class LoginErrorComponent {
  title: string;
  message: string;
  error_message: any;
  isChrome: any = false;
  constructor(
    public dialogRef: MatDialogRef<LoginErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorModel
  ) {
    this.error_message = localStorage.getItem('errorMsg');
    if (navigator.userAgent.indexOf('Chrome') != -1) {
      console.log('Browser Chrome');
      this.isChrome = true;
    }
  }

  confirm(): void {
    localStorage.removeItem('errorMsg');
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  refresh(): void {
    window.location.reload();
  }
}
// <div class="text-center" style="padding-bottom: 15px;">
//           Please check FAQ
//           <a href="assets/clg_path_document.pdf" target="_blank">Link</a>
//         </div>
